export const dcaBaseUrl = '/admin/audience-campaigns'
export const dcaSettingsUrl = '/admin/settings/audiences-and-campaigns'

export const dcaTollFreeSearchUrl = `${dcaSettingsUrl}/search-toll-free`
export const dcaTollFreeRegisterUrl = `${dcaSettingsUrl}/register-toll-free`

export const dcaTemplatesUrl = `${dcaBaseUrl}/templates`
export const dcaSystemTemplatesUrl = `${dcaTemplatesUrl}/new`
export const dcaTemplatesCreateUrl = `${dcaTemplatesUrl}-create`
